import React, { FC } from 'react';
import close from '@assets/map-close.svg';
import useDeviceType from '@hooks/useDeviceType';
import st from '../Main.module.css';

type MobileBtnOpenHomeProps = {
  onClick: () => void;
};

const MobileBtnOpenHome: FC<MobileBtnOpenHomeProps> = ({ onClick }) => {
  const { phone } = useDeviceType();

  if (!phone) {
    return null;
  }
  return (
    <button type="button" className={st.MobileBtnOpenHome} onClick={onClick}>
      <img src={close} alt="close" width={18} height={18} />
    </button>
  );
};

export default MobileBtnOpenHome;
